/**
 * CNPJ Alfanumérico (IN RFB nº 2.229/2024).
 *
 * As 12 primeiras posições podem conter letras maiúsculas A-Z e dígitos 0-9;
 * as 2 últimas (dígitos verificadores) continuam numéricas. Comprimento total: 14.
 *
 * O cálculo dos DVs usa o algoritmo de módulo 11 com os mesmos pesos do CNPJ
 * numérico, atribuindo a cada caractere o valor `(charCode - 48)`, de modo
 * que '0'..'9' -> 0..9 e 'A'..'Z' -> 17..42 (compatível com o CNPJ numérico).
 */

const W1 = [5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2]
const W2 = [6, 5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2]

export function clearFormatting(value) {
  return (value ?? '')
    .replace(/[.\-/]/g, '')
    .toUpperCase()
    .trim()
}

export function isValidCnpj(value) {
  const v = clearFormatting(value)
  if (!/^[A-Z0-9]{12}\d{2}$/.test(v)) return false
  if (/^(.)\1{11}/.test(v.slice(0, 12))) return false

  const digits = [...v].map(c => c.charCodeAt(0) - 48)
  let s1 = 0
  let s2 = 0
  for (let i = 0; i < 12; i += 1) {
    s1 += digits[i] * W1[i]
    s2 += digits[i] * W2[i]
  }
  let dv1 = s1 % 11
  dv1 = dv1 < 2 ? 0 : 11 - dv1
  s2 += dv1 * W2[12]
  let dv2 = s2 % 11
  dv2 = dv2 < 2 ? 0 : 11 - dv2
  return digits[12] === dv1 && digits[13] === dv2
}

export function formatCnpj(value) {
  const v = clearFormatting(value)
  if (v.length !== 14) return value ?? ''
  return `${v.slice(0, 2)}.${v.slice(2, 5)}.${v.slice(5, 8)}/${v.slice(8, 12)}-${v.slice(12)}`
}

export function isAlphanumericCnpj(value) {
  return /[A-Z]/.test(clearFormatting(value))
}
